module.exports = __webpack_public_path__ + "media/images/ibjjf/safe-sport-3-89e4c8dce783a9e97c765e8f648bfa00.svg";